export const corporateRoles = {
  AMM: "AMM",
  ANONYMOUS: "ANONYMOUS",
  ARS: "ARS",
  CTM: "CTM",
  TRAVELER: "TRAVELER",
};
